import React from "react";
import { Box, Paper, Typography } from "../../mui";
import UIBreadcrumbs from "../UIBreadcrumbs";
import UIStepper from "./UIStepper";

const UIWrapper = (props) => {
  const { title, stepper, paper, steps, activeStep, icons } = props;

  return (
    <Box>
      <UIBreadcrumbs />
      {stepper ? (
        <Box component={paper ? Paper : null} p={2} mt={2}>
          <UIStepper steps={steps} activeStep={activeStep} icons={icons} />
          {paper && props.children}
        </Box>
      ) : (
        <Typography variant="h4" color="secondary.dark" sx={{ mt: 2, mb: 1 }}>
          {title}
        </Typography>
      )}
      {(!stepper && paper) && <Box component={Paper} p={2} mt={2}>{props.children}</Box>}
      {(!stepper && !paper) && <Box>{props.children}</Box>}
    </Box>
  );
};

export default UIWrapper;
